import { string } from 'prop-types';
import { complement, isEmpty, prop } from 'ramda';
import { branch, compose, defaultProps, setDisplayName, setPropTypes } from 'recompose';
import { withAppLoadedAnalytics } from '../../utils/hoc/bi/withAppLoadedAnalytics';
import { withTrackSiteFilesAnalytics } from '../../utils/hoc/bi/withTrackSiteFilesAnalytics';
import { onPropChange } from '../../utils/hoc/onPropChange';
import { withItemsActions } from '../../utils/hoc/withItemsActions';
import { withItemsReducer } from '../../utils/hoc/withItemsReducer';
import { withSources } from '../../utils/hoc/withSources';
import { IInner, IOuter } from './FilesManager.types';

export const enhance = compose<IInner, IOuter>(
  setPropTypes({
    fileType: string.isRequired,
  }),
  setDisplayName('FilesManagerEnhance'),
  defaultProps({
    selectedItems: [],
    hasSelectedItems: false,
  }),
  withSources,
  withTrackSiteFilesAnalytics,
  branch(complement(prop('isHome')), compose(withItemsReducer, withItemsActions())),
  withAppLoadedAnalytics,
  onPropChange(['isLoading', 'items'], ({ isMediaFromWix, items, isLoading, trackMediaManagerLoaded }) => {
    if (isMediaFromWix) {
      // public source briefly triggers `isLoading` to false before items are loaded
      if (!isLoading && !isEmpty(items)) {
        trackMediaManagerLoaded();
      }
    } else if (!isLoading) {
      trackMediaManagerLoaded();
    }
  }),
);
